import { SearchContextProvider } from '@backstage/plugin-search-react';
import {Content, ContentHeader, Header, Page, SupportButton} from '@backstage/core-components';
import {
  WelcomeTitle,
  HomePageStarredEntities,
  HomePageTopVisited,
  HomePageRecentlyVisited,
  HeaderWorldClock,
  CustomHomepageGrid,
  ClockConfig,
} from '@backstage/plugin-home';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { PostsTableCard } from '@drodil/backstage-plugin-qeta';
import {
  NotificationTableCard,
  Banner,
  QuickActionBar,
  Toolkit,
} from '@zeiss/backstage-plugin-home-react';

const clockConfigs: ClockConfig[] = [
  {
    label: 'GER',
    timeZone: 'Europe/Berlin',
  },
  {
    label: 'HUN',
    timeZone: 'Europe/Budapest',
  },
  {
    label: 'IST',
    timeZone: 'Asia/Kolkata',
  },
  {
    label: 'CST',
    timeZone: 'Asia/Shanghai',
  },
  {
    label: 'UTC',
    timeZone: 'UTC',
  },
];

const timeFormat: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
};

const defaultConfig = [
  {
    component: 'HomePageSearchBar',
    x: 0,
    y: 0,
    width: 6,
    height: 2,
  },
  {
    component: 'QuickActionBar',
    x: 7,
    y: 0,
    width: 6,
    height: 2,
  },
  {
    component: 'HomePageStarredEntities',
    x: 0,
    y: 1,
    width: 3,
    height: 7,
  },
  {
    component: 'PostsTableCard',
    x: 6,
    y: 1,
    width: 6,
    height: 8,
  },
  {
    component: 'HomePageTopVisited',
    x: 0,
    y: 2,
    width: 3,
    height: 7,
  },
  {
    component: 'HomePageRecentlyVisited',
    x: 3,
    y: 2,
    width: 3,
    height: 7,
  },
  {
    component: 'Toolkit',
    x: 6,
    y: 2,
    width: 6,
    height: 6,
  },
];

export const HomePage = () => {
  return (
    <SearchContextProvider>
      <Page themeId="home">
        <Header
          title="ZEISS Developer Portal"
          subtitle={<WelcomeTitle language={['English']} />}
        >
          <HeaderWorldClock
            clockConfigs={clockConfigs}
            customTimeFormat={timeFormat}
          />
        </Header>
        <Content>
          <Banner />
          <ContentHeader title="">
            <SupportButton />
          </ContentHeader>
          <CustomHomepageGrid config={defaultConfig}>
            <HomePageSearchBar />
            <QuickActionBar />
            <HomePageStarredEntities />
            <PostsTableCard />
            <HomePageTopVisited />
            <HomePageRecentlyVisited />
            <Toolkit />
            <NotificationTableCard />
          </CustomHomepageGrid>
        </Content>
      </Page>
    </SearchContextProvider>
  );
};
